import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'app/api/services/local-storage-service';
import { getTenantsAsDataList } from 'app/helpers/arrayToDataListOptonConverter';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { DatalistOption } from 'app/state/abstract/base.repository';
import { getStoredToken } from 'app/state/auth.repository';
import { AuthService } from 'app/state/auth.service';
import { filter, firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styleUrls: ['./pagenotfound.component.scss'],
    standalone: false
})
export class PagenotfoundComponent implements OnInit {
  tenantId: string | null;
  remainingPath: string | null;
  tenantOptions: DatalistOption[] = [];
  isRedirectAllowed = false;
  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private storage: LocalStorageService,
    public generalDataRepo: GeneralDataRepository,
    public router: Router
  ) {
    const tenantId = this.route.snapshot.paramMap.get('deepTenantId');
    const remainingPath = this.route.snapshot.paramMap.get('remainingPath');
    this.remainingPath = remainingPath;
    this.tenantId = tenantId;
  }

  ngOnInit() {
    this.auth.getGeneralAppDataForUser().subscribe((f) => {
      let tenantsOptions = getTenantsAsDataList(f.tenants);

      if (tenantsOptions.map((f) => f.value).includes(this.tenantId)) {
        this.isRedirectAllowed = true;
      } else {
        this.isRedirectAllowed = false;
      }
    });
  }

  redirectToAnotherTenant() {
    if (this.tenantId) {
      localStorage.setItem('activeTenantId', this.tenantId);
    } else {
      localStorage.removeItem('activeTenantId');
    }
    let token = getStoredToken();
    this.auth.setActiveTenant(token!, this.tenantId).subscribe(() => {
      this.storage.setTenantId(this.tenantId);
      this.generalDataRepo.updateAllGeneralData(true);
      this.router.navigate([this.remainingPath]).then(() => {
        window.location.reload();
        this.generalDataRepo.updateAllGeneralData(true);
      });
    });
  }

  redirectHome() {
    this.router.navigate(['/home']).then(() => {
      window.location.reload();
    });
  }
}
